import React from 'react';
import './Details.scss';

const Details = ({children}) => {
  return <div className='details'>{children}</div>;
};

export default Details;
